import React from "react";
import { Link, useParams } from "react-router-dom";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import { useGetStudentByIdQuery } from "../api/studentApi";
import { API_CONFIG } from "../../../../core/config";
import { all_routes } from "../../../router/all_routes";
import { formatDateToYMD } from "../../../../core/utils/dateFormatter";
const StudentSidebar = () => {
  const { id } = useParams<{ id: string }>();
  const {
    data: studentResponse,
    isLoading,
    error,
  } = useGetStudentByIdQuery({ id: id || "" });
  const student = studentResponse?.data?.student;

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading student data</div>;
  }

  return (
    <div className="col-xxl-3 col-xl-4 theiaStickySidebar">
      <div className="stickybar pb-4">
        <div className="card border-white">
          <div className="card-header">
            <div className="d-flex align-items-center flex-wrap row-gap-3">
              <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                {student?.docs?.photo ? (
                  <img
                    src={`${API_CONFIG.BASE_URL}students/get-thumbnail/${student.docs.photo
                      }?v=${new Date().getTime()}`}
                    className="img-fluid"
                    alt="Student"
                    onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                      const target = e.target as HTMLImageElement;
                      target.src =
                        student.profile.gender?.toLowerCase() === "female"
                          ? "/assets/img/profiles/default-female.png"
                          : "/assets/img/profiles/default-male.png";
                    }}
                  />
                ) : (
                  <ImageWithBasePath
                    src={
                      student?.profile?.gender?.toLowerCase() === "female"
                        ? "assets/img/profiles/default-female.png"
                        : "assets/img/profiles/default-male.png"
                    }
                    className="img-fluid"
                    alt="Student"
                  />
                )}
              </div>
              <div className="overflow-hidden">
                <span
                  className={`badge badge-soft-${student?.status?.toLowerCase() === "active"
                    ? "success"
                    : student?.status?.toLowerCase() === "pending"
                      ? "warning"
                      : "danger"
                    } d-inline-flex align-items-center mb-1`}
                >
                  <i className="ti ti-circle-filled fs-5 me-1" />
                  {student?.status === "active"
                    ? "Active"
                    : student?.status === "pending"
                      ? "Pending"
                      : "Deactivated"}
                </span>
                <h5 className="mb-1 text-truncate">
                  {student?.name}
                </h5>
                <p className="text-primary">{student?.profile?.studentid}</p>
              </div>
            </div>
          </div>
          {/* Basic Information */}
          <div className="card-body">
            <h5 className="mb-3">Basic Information</h5>
            <dl className="row mb-0">
              <dt className="col-6 fw-medium text-dark mb-3">Student ID</dt>
              <dd className="col-6 mb-3 textwrap" style={{ whiteSpace: 'nowrap' }}>
                {student?.profile?.studentid}
              </dd>
              <dt className="col-6 fw-medium text-dark mb-3">Gender</dt>
              <dd className="col-6 mb-3">
                {student?.profile?.gender}
              </dd>
              <dt className="col-6 fw-medium text-dark mb-3">Date Of Birth</dt>
              <dd className="col-6 mb-3">{student?.profile?.dob ? formatDateToYMD(student.profile.dob) : "N/A"}</dd>
              <dt className="col-6 fw-medium text-dark mb-3">Course</dt>
              <dd className="col-6 mb-3 textwrap" style={{ whiteSpace: 'nowrap' }}>{student?.course?.name}</dd>
              <dt className="col-6 fw-medium text-dark mb-3">Level</dt>
              <dd className="col-6 mb-3 textwrap" style={{ whiteSpace: 'nowrap' }}>{student?.course?.stage?.name}</dd>
              <dt className="col-6 fw-medium text-dark mb-3">Batch</dt>
              <dd className="col-6 mb-3 textwrap" style={{ whiteSpace: 'nowrap' }}>{student?.batch?.name}</dd>
              <dt className="col-6 fw-medium text-dark mb-3">Starter Kit</dt>
              <dd className="col-6 mb-3">
                <span
                  className={`badge badge-soft-${student?.skit_assigned ? "success" : "warning"
                    } d-inline-flex align-items-center`}
                >
                  <i className={`ti ti-${student?.skit_assigned ? "check" : "circle-x"} fs-5 me-1`}></i>
                  {student?.skit_assigned ? "Assigned" : "Pending"}
                </span>
              </dd>
            </dl>
            <Link
              className="btn btn-primary btn-sm w-100"
              to={`${all_routes.generateStudentID.replace(
                ":id",
                student?.id?.toString() || ""
              )}`}
            >
              <i className="ti ti-id-badge me-2" />
              Generate Student ID
            </Link>
          </div>
          {/* /Basic Information */}
        </div>
        {/* Primary Contact Info */}
        <div className="card border-white">
          <div className="card-body">
            <h5 className="mb-3">Contact Information</h5>
            <div className="d-flex align-items-center mb-3">
              <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                <i className="ti ti-phone" />
              </span>
              <div>
                <span className="text-dark fw-medium mb-1">Phone Number</span>
                <p>{student?.profile?.phone}</p>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                <i className="ti ti-mail" />
              </span>
              <div>
                <span className="text-dark fw-medium mb-1">Email Address</span>
                <p>{student?.profile?.email}</p>
              </div>
            </div>
          </div>
        </div>
        {/* /Contact Information */}
      </div>
    </div>
  );
};

export default StudentSidebar;
